// Moved verbatim out of the original single-file App.tsx. Markup and classes are
// unchanged — the meeting tool is live and this restructure must not alter it.

import type { ExtractResult } from '../../lib/briefblip';

export function MeetingMeta({ result }: { result: ExtractResult }) {
  const attendees = result.attendees ?? [];
  const hasWhen = !!(result.meeting_date || result.meeting_time || result.location);
  if (!hasWhen && attendees.length === 0) return null;

  return (
    <div className="rounded-xl border border-edge bg-darker/80 p-5">
      {hasWhen && (
        <div className="mb-3 flex flex-wrap gap-x-5 gap-y-1 font-mono text-xs text-[#5f6978]">
          {(result.meeting_date || result.meeting_time) && (
            <span>
              <span className="text-[#7a8493]">When </span>
              {[result.meeting_date, result.meeting_time].filter(Boolean).join(' - ')}
            </span>
          )}
          {result.location && (
            <span>
              <span className="text-[#7a8493]">Where </span>
              {result.location}
            </span>
          )}
        </div>
      )}

      {attendees.length > 0 && (
        <div>
          <h3 className="mb-2 font-mono text-sm uppercase tracking-wider text-cyan">
            Attendees{' '}
            <span className="rounded-full bg-cyan/10 px-2 py-0.5 text-[0.7rem]">
              {attendees.length}
            </span>
          </h3>
          <div className="flex flex-wrap gap-2">
            {attendees.map((a, i) => (
              <span
                key={i}
                className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs ${
                  a.internal
                    ? 'border-cyan/40 bg-cyan/10 text-[#17202c]'
                    : 'border-edge bg-white/80 text-[#5f6978]'
                }`}
                title={
                  a.internal
                    ? [a.title, a.department].filter(Boolean).join(' - ') || 'Internal staff'
                    : 'External'
                }
              >
                {a.internal && <span className="h-1.5 w-1.5 rounded-full bg-cyan" />}
                <span className="font-medium">{a.name}</span>
                {(a.title || a.role) && (
                  <span className="text-[#7a8493]">- {a.title || a.role}</span>
                )}
                {a.internal && (
                  <span className="ml-0.5 font-mono text-[0.6rem] uppercase tracking-wider text-cyan">
                    staff
                  </span>
                )}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
